var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-flex',[(_vm.breadcrumbs)?[_c('tw-title-bar',{attrs:{"title":_vm.breadcrumbs.title,"breadcrumbs":_vm.breadcrumbs.breadcrumbs}})]:_vm._e(),_vm._v(" "),_c('v-container',{staticClass:"ma-0"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_vm._t("default")],2)],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0929d6e5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TwContentWrapper.vue
// module id = null
// module chunks = 